import { useEffect, useState } from "react";

import PageHeader from "../components/PageHeader.jsx";
import apiClient from "../services/api.js";

const buildFormState = () => ({
  project_name: "",
  farm_location: "",
  crop_type: "",
  amount: ""
});

export default function AgricFinancePage() {
  const [projects, setProjects] = useState([]);
  const [form, setForm] = useState(() => buildFormState());

  useEffect(() => {
    apiClient
      .get("/agric-finance/")
      .then((response) => setProjects(response.data))
      .catch(() => setProjects([]));
  }, []);

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { data } = await apiClient.post("/agric-finance/", {
      ...form,
      amount: Number(form.amount)
    });
    setProjects((prev) => [data, ...prev]);
    setForm(buildFormState());
  };

  return (
    <div className="space-y-8">
      <PageHeader title="Agric Financing" description="Provide inputs and working capital for farmers." />

      <form onSubmit={handleSubmit} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-4">
        <div className="grid gap-4 md:grid-cols-2">
          <input
            name="project_name"
            value={form.project_name}
            onChange={handleChange}
            placeholder="Project name"
            required
            className="rounded-lg border border-slate-300 px-3 py-2"
          />
          <input
            name="farm_location"
            value={form.farm_location}
            onChange={handleChange}
            placeholder="Farm location"
            className="rounded-lg border border-slate-300 px-3 py-2"
          />
          <input
            name="crop_type"
            value={form.crop_type}
            onChange={handleChange}
            placeholder="Crop type"
            className="rounded-lg border border-slate-300 px-3 py-2"
          />
          <input
            name="amount"
            type="number"
            min="0"
            step="0.01"
            value={form.amount}
            onChange={handleChange}
            placeholder="Funding amount"
            required
            className="rounded-lg border border-slate-300 px-3 py-2"
          />
        </div>
        <button type="submit" className="rounded-lg bg-accent px-4 py-2 font-semibold text-white hover:bg-accent/80">
          Request Agric Funding
        </button>
      </form>

      <div className="grid gap-4 md:grid-cols-2">
        {projects.map((project) => (
          <article key={project.id} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm text-sm">
            <p className="font-semibold text-slate-900">{project.project_name}</p>
            <p className="text-slate-500">
              {project.farm_location || "Unspecified"} &middot; NGN {project.amount}
            </p>
            <p className="text-xs text-slate-400">Crop: {project.crop_type || "Mixed"}</p>
            <span className="mt-2 inline-block rounded-full bg-emerald-100 px-2 py-1 text-xs text-emerald-700">
              {project.status}
            </span>
          </article>
        ))}
        {!projects.length && <p className="text-sm text-slate-500">No agric finance requests yet.</p>}
      </div>
    </div>
  );
}
